import { Box, Stack, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const MetaInfoContainer = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  padding: theme.spacing(2),
  borderRadius: theme.spacing(1),
  gap: theme.spacing(1.5)
}));

export const InfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1)
}));

export const StepsContainer = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(0.5)
}));

export const StepRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isLastStep"
})(({ isLastStep, theme }) => ({
  display: "flex",
  gap: theme.spacing(1.5),
  minHeight: isLastStep ? 46 : 64
}));

export const VisualStepContainer = styled(Stack)(({ theme }) => ({
  alignItems: "center",
  gap: theme.spacing(0.5)
}));

export const IconContainer = styled(Stack)(() => ({
  justifyContent: "center",
  alignItems: "center",
  width: "20px",
  height: "20px",
  aspectRatio: "1/1"
}));

export const StepConnectorLine = styled(Box, {
  shouldForwardProp: (prop) => prop !== "lineColor"
})(({ lineColor, theme }) => ({
  width: "2px",
  height: "100%",
  backgroundColor: lineColor,
  borderRadius: theme.shape.borderRadius * 0.25
}));

export const SuccessContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: theme.palette.success[100],
  borderRadius: theme.spacing(1)
}));

export const SuccessText = styled(Typography)(({ theme }) => ({
  color: theme.palette.success[600],
  lineHeight: "20px"
}));
